import { employeeSalaries } from '@markku/db'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'
import { z } from 'zod'
import type { Role } from './user'

export const selectEmployeeSalarySchema = createSelectSchema(employeeSalaries)

export const insertEmployeeSalarySchema = createInsertSchema(
  employeeSalaries,
).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
})

export type EmployeeSalary = z.infer<typeof selectEmployeeSalarySchema>
export type CreateEmployeeSalary = z.infer<typeof insertEmployeeSalarySchema>

// Who opens the payroll summary (palkkayhteenveto). It shows salary euros, so
// it is held to the roles that may see pay; admin inherits both.
export const PAYROLL_SUMMARY_ROLES: Exclude<Role, 'user'>[] = [
  'management',
  'service_manager',
]
